export var props = {
  modelValue: {
    type: [Array, String, Number]
  },
  accordion: {
    type: Boolean,
    default: false
  },
  offset: {
    type: Boolean,
    default: true
  },
  onChange: {
    type: Function
  },
  'onUpdate:modelValue': {
    type: Function
  }
};